import css from "styled-jsx/css";

const BORDER_COLOR = "#e6e9ef";

export const componentStyles = css.global`
  .component-container {
    display: flex;
    flex-direction: column;
    .title-wrapper {
      margin-bottom: 32px;
      margin-top: 24px;
      font-size: 24px;
      font-weight: 700;
      line-height: 30px;
    }
    .cards-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: 34px;
    }
    .card {
      text-decoration: none;
      border: 0.5px solid;
      border-color: ${BORDER_COLOR};
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      width: 328px;
      margin-bottom: 20px;
      .image-wrapper {
        .picture-component {
          img {
            max-width: 100%;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
          }
        }
      }
      .card-content {
        padding: 16px 24px 24px 24px;
        .card-title {
          font-size: 1.125rem;
          font-weight: 700;
          margin-bottom: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .card-description {
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3; /* number of lines to show */
          -webkit-box-orient: vertical;
        }
      }
      :hover {
        box-shadow: 0px 8px 24px 0 rgba(0, 0, 0, 0.16);
      }
    }
  }
  .show-more {
    text-decoration: underline;
    color: blue;
    text-align: center;
    cursor: pointer;
    margin-top: 32px;
  }
`;
